import React, {memo} from 'react';
import {withGoogleMap, withScriptjs, GoogleMap, Marker, Polygon} from 'react-google-maps';
import {appConfig} from '~/config';

export interface Position {
  lat?: number;
  lng?: number;
}

export interface Props {
  center: Position;
  path?: Position[];
  styles?: any;
}

const Map = memo(function Map({path, center, styles = {}, ...rest}: Props) {
  const renderPath = () => {
    if (!path?.length) return null;
    return (
      <>
        {path.map((val: Position) => (
          <Marker key={`${val.lat}-${val.lng}`} position={{lat: val.lat, lng: val.lng}} />
        ))}
      </>
    );
  };
  return (
    <GoogleMap
      defaultZoom={12}
      defaultCenter={{lat: center.lat, lng: center.lng}}
      center={{lat: center.lat, lng: center.lng}}
      options={{styles}}
      {...rest}
    >
      {renderPath()}
      <Polygon path={path} options={{strokeColor: '#f1f1f1'}} />
    </GoogleMap>
  );
});

const MapComponent = withScriptjs(withGoogleMap(Map));

export default (props: Props) => (
  <MapComponent
    googleMapURL={appConfig.googleMapURL}
    loadingElement={<div style={{height: `100%`}} />}
    containerElement={<div style={{height: `400px`, width: '100%', marginTop: '20px'}} />}
    mapElement={<div style={{height: `100%`}} />}
    {...props}
  />
);
